import WhyCard1 from "../../assets/why-card-1.png";
import WhyCard2 from "../../assets/why-card-2.png";
import WhyCard3 from "../../assets/why-card-3.png";
import WhyCard4 from "../../assets/why-card-4.png";
import WhyCard5 from "../../assets/why-card-5.png";

export default function WhySection() {
  const whyCards = [
    {
      title:
        "Toegang tot een besloten community. Met 40.000+ actieve jongeren.",
      image: WhyCard1,
    },
    {
      title: (
        <span>
          No cure. No pay. <br />
          Zonder risico zichtbaar zijn.
        </span>
      ),
      image: WhyCard2,
    },
    {
      title: "70.000+ tickets verkocht en events geboost.",
      image: WhyCard3,
    },
    {
      title: "1000+ brand deals gesloten voor onze community.",
      image: WhyCard4,
    },
    {
      title: "Actief in Amsterdam, Bali, Barcelona, Ibiza en beyond.",
      image: WhyCard5,
    },
  ];

  return (
    <>
      <section className="md:hidden flex flex-col gap-[16px] mt-[48px]">
        <div className="font-semibold text-[22px] text-white leading-[26px]">
          Waarom venues en brands met ons samenwerken
        </div>
        {whyCards.map((card, index) => (
          <div className="flex flex-col items-center gap-[12px] bg-[#0B0415CC] p-[48px_24px] border-[#292433] border-[1.5px] rounded-[16px] w-full text-center">
            <img
              src={card.image}
              className="w-[220px] h-[200px]"
              alt={`why-card-${index}`}
            />
            <div className="max-w-[240px]">
              <div className="font-normal text-[#F7F2FD] text-[18px] leading-[24px]">
                {card.title}
              </div>
            </div>
          </div>
        ))}
      </section>

      <section className="max-md:hidden flex flex-col gap-[16px] mt-[96px]">
        <div className="mb-[16px] font-semibold text-[36px] text-white leading-[36px] tracking-[-1px]">
          Waarom venues en <br />
          brands met ons samenwerken
        </div>
        <div className="gap-[16px] grid grid-cols-2">
          {whyCards.slice(0, 2).map((card, index) => (
            <div className="flex flex-col items-center gap-[12px] bg-[#0B0415CC] p-[48px_24px] border-[#292433] border-[1.5px] rounded-[16px] w-full text-center">
              <img
                src={card.image}
                className="w-[220px] h-[200px]"
                alt={`why-card-${index}`}
              />
              <div className="max-w-[70%]">
                <div className="font-normal text-[#F7F2FD] text-[22px] leading-[26px] tracking-[-0.5px]">
                  {card.title}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="gap-[16px] grid grid-cols-3">
          {whyCards.slice(2, 5).map((card, index) => (
            <div className="flex flex-col items-center gap-[12px] bg-[#0B0415CC] p-[48px_24px] border-[#292433] border-[1.5px] rounded-[16px] w-full text-center">
              <img
                src={card.image}
                className="w-[220px] h-[200px]"
                alt={`why-card-${index}`}
              />
              <div className="font-normal text-[#F7F2FD] text-[22px] leading-[26px] tracking-[-0.5px]">
                {card.title}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
